import Api from 'src/api/Base'

class ExportChangeControlSkuDetailsByCycleId extends Api {
  requestUrl = `/api/Cycle/${this.getParams().cycleId}/ExportSkuChangeControls`
}
export default ExportChangeControlSkuDetailsByCycleId
